import React from 'react'
import Header from '../components/header/Header'
import Body from '../components/body/Body'
function PageRoot() {
    return (
        <>
            {/* <Header /> */}
            <Body />
        </>
    )
}

export default PageRoot